module.exports = __webpack_public_path__ + "img/80h100_povorotno_otkidnoe.054e6789.svg";